export default "__VITE_ASSET__CoM82jOt__"